import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: $props.link,
    target: $props.target,
    class: _normalizeClass(["button", [
      `button--${$props.skin}`,
      `button--${$props.size}`,
      $props.isDisabled && 'button--disabled',
      $props.isRounded && 'button--rounded',
    ]]),
    style: _normalizeStyle([
      $props.background && `background: var(--${$props.background})`,
      $props.color && `color: var(--${$props.color})`,
    ])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 14, _hoisted_1))
}